import { useEffect, useState } from 'react';
import axios from 'axios';

/* Is the Prices page on for this signed-in provider? (price board plan
   P4: PRICE_BOARD_PROVIDERS, provider by provider.) The three provider
   nav lists show "Prices" instead of "Services" when it is, and
   /provider/services sends them to /provider/prices. One check per
   provider per page load, shared by every caller; undefined until the
   answer is in, so a caller can wait instead of flashing the old page. */

let cached = { userId: null, promise: null, value: undefined };

export default function usePriceBoardEnabled(user) {
  const userId = user?.accountType === 'PROVIDER' ? String(user._id || '') : null;
  const [on, setOn] = useState(() => (userId && cached.userId === userId ? cached.value : (userId ? undefined : false)));
  useEffect(() => {
    if (!userId) { setOn(false); return undefined; }
    let alive = true;
    if (cached.userId !== userId || !cached.promise) {
      const entry = { userId, promise: null, value: undefined };
      entry.promise = axios.get('/api/prices/enabled', { withCredentials: true })
        .then(r => !!(r.data && r.data.enabled))
        .catch(() => false)
        .then(v => { entry.value = v; return v; });
      cached = entry;
    }
    cached.promise.then(v => { if (alive) setOn(v); });
    return () => { alive = false; };
  }, [userId]);
  return on;
}
